/** @jsxImportSource ../../i18n */
import React from 'react';
import { cx } from '../../theme/cx';

const TONES = {
  neutral: 'border-line-strong bg-surface-3 text-fg-muted',
  gold: 'border-gold-500/25 bg-gold-900/70 text-gold-300',
  gain: 'border-gain-500/25 bg-gain-900/70 text-gain-300',
  loss: 'border-loss-500/30 bg-loss-900/70 text-loss-300',
  warn: 'border-warn-500/25 bg-warn-900/70 text-warn-300',
  info: 'border-info-500/25 bg-info-900/70 text-info-300',
  trade: 'border-trade-500/35 bg-trade-900/70 text-trade-200',
};

const SIZES = {
  sm: 'h-6 gap-1 px-2 text-xs',
  md: 'h-7 gap-1.5 px-2.5 text-[13px]',
};

export const Badge = ({ tone = 'neutral', size = 'sm', icon: Icon, dot = false, className, children, ...rest }) => (
  <span className={cx('inline-flex max-w-full items-center whitespace-nowrap rounded-full border font-medium leading-none', TONES[tone] || TONES.neutral, SIZES[size] || SIZES.sm, className)} {...rest}>
    {dot && <span aria-hidden="true" className={cx('h-1.5 w-1.5 flex-shrink-0 rounded-full bg-current', dot === 'pulse' && 'animate-pulse-soft')} />}
    {Icon && <Icon size={size === 'md' ? 14 : 12} aria-hidden="true" className="flex-shrink-0" />}
    <span className="truncate">{children}</span>
  </span>
);
